module.exports = __webpack_public_path__ + "static/media/iStock-1205554119.9e8a1a03.jpg";